import React, {useState} from 'react';

function Links() {
  const [sites] = useState([
    {name: 'Github', url: 'https://www.github.com/Bobj2018'},
    {name: 'LinkedIn', url: 'https://www.linkedin.com/in/joshua-rieth/'},
    {name: 'Twitter', url: 'https://twitter.com/Bobj2018'},
    {name: 'CodePen.io', url: 'https://codepen.io/dashboard/'},
    {name: 'CodeSandbox.io', url: 'https://codesandbox.io/u/Bobj2018'},
  ]);

  return (
    <section id="links" className="px-10 py-4 m-auto bg-white sm:shadow-md sm:w-2/3">
      <h2 className="w-full text-3xl font-bold ">Links</h2>
      <ul>
        {sites.map((site, index) => (
          <li key={index}>
            -{' '}
            <a
              className="text-blue-700 hover:cursor-pointer hover:text-blue-900"
              href={site.url}
            >
              {site.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Links;
